import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Textarea } from "@/components/ui/textarea";
import { SelectField } from "@/components/common/Forms";
import { STATUS } from "@/data/portal";

export const StatusUpdater = ({ endpoint, current, statuses, onSaved, testid = "status-updater" }) => {
  const [status, setStatus] = useState(current);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.patch(endpoint, { status, note });
      toast.success(`Status updated to ${STATUS[status]?.label || status}`);
      setNote("");
      onSaved(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-3 rounded-lg border border-slate-200 bg-[#F4F6F2] p-4" data-testid={testid}>
      <SelectField id={`${testid}-status`} label="Update status" value={status} onChange={setStatus} options={statuses.map((s) => ({ value: s, label: STATUS[s].label }))} />
      <Textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} placeholder="Note (optional, visible to customer for portal requests)" className="bg-white" data-testid={`${testid}-note`} />
      <button onClick={save} disabled={busy} className="btn-dark py-2" data-testid={`${testid}-save-button`}>{busy && <Loader2 className="h-4 w-4 animate-spin" />} Save update</button>
    </div>
  );
};
